module.exports = __webpack_public_path__ + "img/our_app.6f6779c5.svg";